import { portfolioButtonStyles } from '../../../styles';

const Styles = theme => ({
  ...portfolioButtonStyles(theme),
});

export default Styles;
